module.exports = __webpack_public_path__ + "img/logo_彭威.af107068.png";